module.exports = __webpack_public_path__ + "img/no-message.cff485eb.png";